import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ServiceItemCard from "../../components/services/ServiceItemCard";
import { CategoryAPI } from "../../api";
import { Helmet } from "react-helmet-async";

const Category = () => {
	const { category } = useParams();
	const [ServiceCategory, setServiceCategory] = useState([]);
	const [meta, setMeta] = useState({
		title: "",
		description: "",
		keywords: "",
	});

	useEffect(() => {
		CategoryAPI.getCategory(category)
			.then((res) => {
				setServiceCategory(res.data);
				setMeta({
					title: res.data.meta_title || res.data.title,
					description: res.data.meta_description || res.data.short_description,
					keywords: res.data.meta_keywords || res.data.title,
				});
			})
			.catch((err) => console.error(err));
	}, [category]);

	return (
		<>
			<Helmet>
				<title>{meta.title}</title>
				<meta name="description" content={meta.description} />
				<meta name="keywords" content={meta.keywords} />
			</Helmet>
			<section className="container service-slug-page">
				<div className="service-slug-banner">
					<img src={ServiceCategory?.icon_url} alt="" />
					<div>
						<h4 className="text-uppercase Ethnocentric">
							{ServiceCategory?.title}
						</h4>
						<p>{ServiceCategory?.description}</p>
					</div>
				</div>
				<hr />
				<div className="service-item-grid">
					{ServiceCategory?.service_items?.map((service, index) => (
						<ServiceItemCard
							key={index}
							title={service.title}
							slug={service.slug}
							short_description={service.short_description}
							image={service.image}
						/>
					))}
				</div>
			</section>
		</>
	);
};

export default Category;
